const countryKey = 'country-';

export const getCountryTransKey = (id: number): string => (id ? `countries:${countryKey}${id}` : '');
